import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
    selector: 'app-manutencao',
    templateUrl: './manutencao-dialog.html',
    styleUrls: ['./manutencao-dialog.scss', '../../../styles/estilo.padrao.scss']
})
export class AlertaManutencaoDialog {
    uid;

    constructor(
        private dialogRef: MatDialogRef<AlertaManutencaoDialog>,
        @Inject(MAT_DIALOG_DATA) public data: { descricao: string, previsaoRetorno: string }
    ) {
        this.uid = localStorage.getItem('uid')
    }

    forcarAtualizacao() {
        window.location.reload(true);
    }

}
